import React from "react";
import { Helmet } from "react-helmet";

// Define your routes
const routes = [
  { url: "/", changefreq: "weekly", priority: 1.0 },
  { url: "/block-validation-process", changefreq: "weekly", priority: 0.8 },
  { url: "/dao-and-mst-chain", changefreq: "weekly", priority: 0.8 },
  { url: "/fractional-node", changefreq: "weekly", priority: 0.8 },
  { url: "/evm-blockchain", changefreq: "weekly", priority: 0.8 },
  { url: "/transparency", changefreq: "weekly", priority: 0.75 },
  { url: "/build-with-mst", changefreq: "weekly", priority: 0.85 },
  { url: "/community", changefreq: "weekly", priority: 0.75 },
  { url: "/ambassador-programme", changefreq: "weekly", priority: 0.7 },
  // { url: "/team-and-partners", changefreq: "weekly", priority: 0.65 },
  // { url: "/about-mst", changefreq: "weekly", priority: 0.65 },
  { url: "/mst-research-program", changefreq: "weekly", priority: 0.7 },
  { url: "/blogs", changefreq: "weekly", priority: 0.9 },
  {
    url: "/solutions/retail-commerce-and-supply-chain",
    changefreq: "weekly",
    priority: 0.75
  },
  {
    url: "/solutions/nfts-art-and-culture",
    changefreq: "weekly",
    priority: 0.7
  },
  {
    url: "/solutions/decentralized-finance",
    changefreq: "weekly",
    priority: 0.75
  },
  {
    url: "/solutions/enterprise-consumer-apps",
    changefreq: "weekly",
    priority: 0.7
  },
  // { url: "/solutions/gaming", changefreq: "weekly", priority: 0.7 },
  {
    url: "/solutions/institution-and-capital-markets",
    changefreq: "weekly",
    priority: 0.75
  },
  { url: "/kyc-policies", changefreq: "weekly", priority: 0.5 },
  { url: "/aml-policies", changefreq: "weekly", priority: 0.5 },
  { url: "/privacy", changefreq: "weekly", priority: 0.4 },
  { url: "/terms", changefreq: "weekly", priority: 0.4 }
  // { url: "/cancellation", changefreq: "weekly", priority: 0.4 }
];

const Sitemap = () => {
  const xml = `<?xml version="1.0" encoding="UTF-8"?>
<urlset xmlns="http://www.sitemaps.org/schemas/sitemap/0.9">
  ${routes
    .map(
      (route) => `
    <url>
      <loc>${window?.location.origin}${route.url}</loc>
      <changefreq>${route.changefreq}</changefreq>
      <priority>${route.priority}</priority>
    </url>`
    )
    .join("")}
</urlset>`;

  return (
    <Helmet>
      <meta name="sitemap" content={xml} />
    </Helmet>
  );
};

export default Sitemap;
